export default __webpack_public_path__ + "static/media/480_business01-nl-mobile.b8cc310e.png";